import { render, staticRenderFns } from "./message-plugin-layout.vue?vue&type=template&id=3230408b&scoped=true"
import script from "./message-plugin-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-plugin-layout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-plugin-layout.vue?vue&type=style&index=0&id=3230408b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230408b",
  null
  
)

export default component.exports